import Home from '../components/Home'
import Login from '../components/Login'
import Other from '../components/Other'
import ForgotPassword from '../components/ForgotPassword'
import ResetPassword from '../components/ResetPassword'
import MenuResetPassword from '../components/MenuResetPassword'
import MoralStart from '../components/MoralStart'
import MoralGuidance from '../components/MoralGuidance'
import MoralCheck from '../components/MoralCheck'
import MoralCheckList from '../components/MoralCheckList'
import MoralSent from '../components/MoralSent'
import MessageSent from '../components/MessageSent'
import MessageSentManager from '../components/MessageSentManager'
import MessageSentOfficer from '../components/MessageSentOfficer'
import MessageSentHarassment from '../components/MessageSentHarassment'
import ProposeMyshopList from '../components/ProposeMyshopList'
import ProposeAllshopList from '../components/ProposeAllshopList'
import ProposeAdoptList from '../components/ProposeAdoptList'
import ProposeSearchList from '../components/ProposeSearchList'
import ProposePersonalList from '../components/ProposePersonalList'
import ProposeNew from '../components/ProposeNew'
import ProposeDetail from '../components/ProposeDetail'
import ProposeEdit from '../components/ProposeEdit'
import ProposeRejectedList from '../components/ProposeRejectedList'
import ProposeRejectedDetail from '../components/ProposeRejectedDetail'
import MoralNoanswerList from '../components/MoralNoanswerList'
import MessageSendManager from '../components/MessageSendManager'
import MessageSendOfficer from '../components/MessageSendOfficer'
import MessageSendHarassment from '../components/MessageSendHarassment'
import MessageList from '../components/MessageList'
import MessageDetail from '../components/MessageDetail'
import ProfileDetail from '../components/ProfileDetail'
import ProfileEdit from '../components/ProfileEdit'
import RequestHolidayNew from '../components/RequestHolidayNew'
import RequestHolidaySent from '../components/RequestHolidaySent'
import ShiftList from '../components/ShiftList'
import ShiftDetail from '../components/ShiftDetail'
import MagazineList from '../components/MagazineList'
import WillMustEdit from '../components/WillMustEdit'
import WillMustSent from '../components/WillMustSent'
import WillMustList from '../components/WillMustList'
import WillMustDetail from '../components/WillMustDetail'
import DocumentRenewalList from '../components/DocumentRenewalList'
import PayrollList from '../components/PayrollList'
import Onboarding from '../components/Onboarding'
import Referral from '../components/Referral'
import Introduction from '../components/Introduction'
import VideoCategories from '../components/VideoCategories'
import VideoCourtesy from '../components/VideoCourtesy'
import VideoCustomerService from '../components/VideoCustomerService'
import VideoRawFacility from '../components/VideoRawFacility'
import VideoServiceQuestionPoint from '../components/VideoServiceQuestionPoint'
import YesWeCan from '../components/YesWeCan'
import StepUpQuestionCheck from '../components/StepUpQuestionCheck'
import StepUpCallList from '../components/StepUpCallList'
import StepUpAnswerEdit from '../components/StepUpAnswerEdit'
import StepUpAnswerList from '../components/StepUpAnswerList'
import EsMyCardLikeList from '../components/EsMyCardLikeList'
import EsMyCardList from '../components/EsMyCardList'
import EsMyCardDetail from '../components/EsMyCardDetail'
import FacingTypeCardExchangeSelect from '../components/FacingTypeCardExchangeSelect'
import FacingTypeCardNew from '../components/FacingTypeCardNew'
import EsMyCardMyList from '../components/EsMyCardMyList'
import EsMyCardFavoriteList from '../components/EsMyCardFavoriteList'
import EsMyCardSelectDesign from '../components/EsMyCardSelectDesign'
import EsMyCardDesignPreview from '../components/EsMyCardDesignPreview'
import EsMyCardSendList from '../components/EsMyCardSendList'
import EsMyCardNew from '../components/EsMyCardNew'
import EsMyCardPreview from '../components/EsMyCardPreview'
import CompanyNoticeList from '../components/CompanyNoticeList'
import CompanyNoticeDetail from '../components/CompanyNoticeDetail'
import TreatmentSalaryList from '../components/TreatmentSalaryList'
import TreatmentLeaveList from '../components/TreatmentLeaveList'
import TreatmentRuleList from '../components/TreatmentRuleList'
import TreatmentDetail from '../components/TreatmentDetail'
import EvaluateAnswerEdit from '../components/EvaluateAnswerEdit'
import EvaluateAnswerCallList from '../components/EvaluateAnswerCallList'
import EvaluateAnswerList from '../components/EvaluateAnswerList'
import EvaluateQuestionCheck from '../components/EvaluateQuestionCheck'
import ServiceAnswerList from '../components/ServiceAnswerList'
import ServiceAnswerCallList from '../components/ServiceAnswerCallList'
import ServiceAnswerEdit from '../components/ServiceAnswerEdit'
import SafetyConfirmationEdit from '../components/SafetyConfirmationEdit'

export default {
  data: [
    {name: 'home', path: '/', component: Home},
    {name: 'login', path: '/login', component: Login, meta: {noAuth: true}},
    {name: 'Onboarding', path: '/onboarding', component: Onboarding, meta: {noAuth: true}}, // 入社手続き（招待トークン。ログイン前）
    {name: 'forgotPassword', path: '/forgot_password', component: ForgotPassword, meta: {noAuth: true}},
    {name: 'resetPassword', path: '/reset_password', component: ResetPassword, meta: {noAuth: true}},
    {name: 'menuResetPassword', path: '/menu_reset_password', component: MenuResetPassword},
    {name: 'moralStart', path: '/moral_start', component: MoralStart},
    {name: 'moralGuidance', path: '/moral_guidance', component: MoralGuidance},
    {name: 'moralCheck', path: '/moral_check/:id', component: MoralCheck},
    {name: 'moralCheckList', path: '/moral_check_list', component: MoralCheckList},
    {name: 'moralSent', path: '/moral_sent', component: MoralSent},
    {name: 'messageSent', path: '/message_sent', component: MessageSent},
    {name: 'messageSentManager', path: '/message_sent_manager', component: MessageSentManager},
    {name: 'messageSentOfficer', path: '/message_sent_officer', component: MessageSentOfficer},
    {name: 'messageSentHarassment', path: '/message_sent_harassment', component: MessageSentHarassment},
    {name: 'proposeMyshopList', path: '/propose_myshop_list', component: ProposeMyshopList},
    {name: 'proposeAdoptList', path: '/propose_adopt_list', component: ProposeAdoptList},
    {name: 'proposeAllshopList', path: '/propose_allshop_list', component: ProposeAllshopList},
    {name: 'proposeSearchList', path: '/propose_search_list', component: ProposeSearchList},
    {name: 'proposePersonalList', path: '/propose_personal_list/:id', component: ProposePersonalList},
    {name: 'proposeNew', path: '/propose/new', component: ProposeNew},
    {name: 'proposeRejectedList', path: '/propose_rejected_list', component: ProposeRejectedList},
    {name: 'proposeRejectedDetail', path: '/propose_rejected/:id', component: ProposeRejectedDetail},
    {name: 'proposeDetail', path: '/propose/:id', component: ProposeDetail},
    {name: 'proposeEdit', path: '/propose/:id/edit', component: ProposeEdit},
    {name: 'moralNoanswerList', path: '/moral_noanswer_list', component: MoralNoanswerList},
    {name: 'messageSendManager', path: '/message_send_manager', component: MessageSendManager},
    {name: 'messageSendOfficer', path: '/message_send_officer', component: MessageSendOfficer},
    {name: 'messageSendHarassment', path: '/message_send_harassment', component: MessageSendHarassment},
    {name: 'messageList', path: '/message_list', component: MessageList},
    {name: 'messageDetail', path: '/message/:id', component: MessageDetail},
    {name: 'profileDetail', path: '/profile/:id', component: ProfileDetail},
    {name: 'profileEdit', path: '/profile/:id/edit', component: ProfileEdit},
    {name: 'requestHolidayNew', path: '/request_holiday/new', component: RequestHolidayNew},
    {name: 'RequestHolidaySent', path: '/request_holiday_sent', component: RequestHolidaySent},
    {name: 'shiftList', path: '/shift_list/:ym', component: ShiftList}, // :idはyyyy-mm
    {name: 'shiftDetail', path: '/shift_detail/:ymd', component: ShiftDetail}, // :idはyyyy-mm-dd
    {name: 'MagazineList', path: '/magazine_list', component: MagazineList},
    {name: 'WillMustEdit', path: '/will_must/edit', component: WillMustEdit},
    {name: 'WillMustSent', path: '/will_must_sent', component: WillMustSent},
    {name: 'WillMustList', path: '/will_must_list', component: WillMustList},
    {name: 'WillMustDetail', path: '/will_must/:id', component: WillMustDetail},
    {name: 'DocumentRenewalList', path: '/document_renewals', component: DocumentRenewalList}, // 書類の更新提出（P12）
    {name: 'PayrollList', path: '/payroll/documents', component: PayrollList}, // 給与・賞与明細（F-PAY-02）
    {name: 'PayrollDocument', path: '/payroll/documents/:id', component: PayrollList}, // ワンタイムリンクからの個別表示
    {name: 'VideoCategories', path: '/video_categories', component: VideoCategories},
    {name: 'VideoCourtesy', path: '/video_courtesy', component: VideoCourtesy},
    {name: 'VideoCustomerService', path: '/video_customer_service', component: VideoCustomerService},
    {name: 'VideoRawFacility', path: '/video_raw_facility', component: VideoRawFacility},
    {name: 'VideoServiceQuestionPoint', path: '/video_service_question_point', component: VideoServiceQuestionPoint},
    {name: 'YesWeCan', path: '/yes_we_can', component: YesWeCan},
    {name: 'Referral', path: '/referral', component: Referral},
    {name: 'Introduction', path: '/introduction/:send_token', component: Introduction, meta: {noAuth: true}},
    {name: 'StepUpQuestionCheck', path: '/stepup/question_check', component: StepUpQuestionCheck},
    {name: 'StepUpCallList', path: '/stepup/call_list', component: StepUpCallList},
    {name: 'StepUpAnswerEdit', path: '/stepup/:step_up_answer_id/edit', component: StepUpAnswerEdit},
    {name: 'StepUpAnswerList', path: '/stepup/:step_up_answer_id/answered_list', component: StepUpAnswerList},
    {name: 'EsMyCardLikeList', path: '/like_list/:es_mycard_id', component: EsMyCardLikeList},
    {name: 'EsMyCardList', path: '/es_mycard_list', component: EsMyCardList},
    {name: 'EsMyCardDetail', path: '/es_mycard/:es_mycard_id/detail', component: EsMyCardDetail},
    {name: 'FacingTypeCardExchangeSelect', path: '/facing_type_card/exchange_select', component: FacingTypeCardExchangeSelect, meta: {noAuth: true}},
    {name: 'FacingTypeCardGiveNew', path: '/facing_type_card/give_new', component: FacingTypeCardNew},
    {name: 'FacingTypeCardGetNew', path: '/facing_type_card/get_new', component: FacingTypeCardNew},
    {name: 'EsMyCardMyList', path: '/es_mycard_list/:user_id', component: EsMyCardMyList},
    {name: 'EsMyCardFavoriteList', path: '/es_mycard_favorite_list', component: EsMyCardFavoriteList},
    {name: 'EsMyCardSelectDesign', path: '/select_design', component: EsMyCardSelectDesign},
    {name: 'EsMyCardDesignPreview', path: '/select_design/preview', component: EsMyCardDesignPreview},
    {name: 'EsMyCardSendList', path: '/send_list', component: EsMyCardSendList},
    {name: 'EsMyCardNew', path: '/es_mycard/new', component: EsMyCardNew},
    {name: 'EsMyCardPreview', path: '/es_mycard/preview', component: EsMyCardPreview},
    {name: 'CompanyNoticeList', path: '/company_notice_list', component: CompanyNoticeList},
    {name: 'CompanyNoticeDetail', path: '/company_notice/:company_notice_id/detail', component: CompanyNoticeDetail},
    {name: 'TreatmentSalaryList', path: '/treatment_salary_list', component: TreatmentSalaryList},
    {name: 'TreatmentLeaveList', path: '/treatment_leave_list', component: TreatmentLeaveList},
    {name: 'TreatmentRuleList', path: '/treatment_rule_list', component: TreatmentRuleList},
    {name: 'TreatmentDetail', path: '/treatment_detail/:pass', component: TreatmentDetail},
    {name: 'EvaluateAnswerEdit', path: '/evaluate_answer/:id/edit', component: EvaluateAnswerEdit},
    {name: 'EvaluateAnswerCallList', path: '/evaluate_answer/call_list', component: EvaluateAnswerCallList},
    {name: 'EvaluateAnswerList', path: '/evaluate_answer/:id/answered_list', component: EvaluateAnswerList},
    {name: 'EvaluateQuestionCheck', path: '/evaluate_answer/:id/question_check', component: EvaluateQuestionCheck},
    {name: 'ServiceAnswerList', path: '/service_answers', component: ServiceAnswerList},
    {name: 'ServiceAnswerCallList', path: '/service_answer_calls', component: ServiceAnswerCallList},
    {name: 'ServiceAnswerEdit', path: '/service_answers/:id', component: ServiceAnswerEdit},
    {name: 'SafetyConfirmationEdit', path: '/safety_confirmation', component: SafetyConfirmationEdit},
    {name: 'other', path: '*', component: Other}
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes.js